const ProgressBar = ({ progress, label }) => (
  <div className="upload-wrapper">
    <div className="upload-bar">
      <div className="upload-bar-fill" style={{ width: `${progress}%` }}>
        <span className="upload-bar-text">{label} {progress}%</span>
      </div>
    </div>
  </div>
);

export default ProgressBar;
